import './App.css';
import Navbar from './components/Home/Navbar/Navbar';
import Fondo from './components/Home/Fondo/Fondo';
import Sliders from './components/Home/Sliders/Sliders.jsx';
import About from './components/Home/About/About.jsx';
import Footer from './components/Home/Footer/Footer.jsx';
import ProductSliders from './components/Products/Sliders/productSliders.jsx';
import Marcas from './components/Products/Marcas/Marcas.jsx';
import Categorias from './components/Products/Categorias/Categorias.jsx';
import Contacto from './components/Contact/Contacto.jsx';
import Nosotros from './components/About/Nosotros.jsx';
import Delice from './components/Products/Categorias/Delice/Delice.jsx';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DetalleProduct from './components/Products/Categorias/Detalles/DetalleProduct.jsx';
import WhatsappButton from './Whatsapp/WhatsappButton.jsx';

import ScrollToTop from './ScrollToTop.jsx';

function App() {

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <WhatsappButton />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Fondo />
              <div className="Sliders">
                <Sliders />
              </div>
              <About />
              <Footer />
            </>
          }
        />
        <Route
          path="/productos"
          element={
            <>
              <ProductSliders />
              <Marcas />
              <Categorias />
              <Footer />
            </>
          }
        />
        <Route
          path="/categoria/:nombre"
          element={
            <>
              <Delice />
              <Footer />  
            </> 
          }
        />
         <Route
          path="/categoria/:nombre/:subtitulo"
          element={
            <>
              <DetalleProduct />
              <Footer />
            </>
          }
        />
        <Route
          path="/contacto"
          element={
            <>
              <Contacto />
              <Footer />
            </>
          }
        />
        <Route
          path="/nosotros"
          element={
            <>
              <Nosotros />
              <Footer />
            </>
          }
        />
        <Route
          path="*"
          element={<h1>404 - Página no encontrada</h1>}
        />
      </Routes>
    </Router>
  );
}

export default App;
